import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import LandingPage from './components/LandingPage';
import QuestionnaireFlow from './components/QuestionnaireFlow';
import ResultsPage from './components/ResultsPage';
import FinalCTA from './components/FinalCTA';
import './App.css';

function App() {
  const [userResponses, setUserResponses] = useState({});

  const updateResponses = (newResponses) => {
    setUserResponses(prev => ({
      ...prev,
      ...newResponses
    }));
  };

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
        <AnimatePresence mode="wait">
          <Routes>
            <Route 
              path="/" 
              element={<LandingPage />} 
            />
            <Route 
              path="/questionnaire" 
              element={
                <QuestionnaireFlow 
                  responses={userResponses} 
                  updateResponses={updateResponses} 
                />
              } 
            />
            <Route 
              path="/results" 
              element={
                <ResultsPage 
                  responses={userResponses} 
                />
              } 
            />
            <Route 
              path="/get-coverage" 
              element={<FinalCTA />} 
            />
          </Routes>
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;